import { render } from "./OportunitiesSection.vue?vue&type=template&id=7e5a3638&scoped=true"
import script from "./OportunitiesSection.vue?vue&type=script&lang=js"
export * from "./OportunitiesSection.vue?vue&type=script&lang=js"

import "./OportunitiesSection.vue?vue&type=style&index=0&id=7e5a3638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5a3638"]])

export default __exports__